import type { LinkGroupHeadingPropsType } from './types';

const LinkGroupHeading: React.FC<LinkGroupHeadingPropsType> = (props: LinkGroupHeadingPropsType) => (
  <div className="border-b border-accent mb-5">
    <h2 className="tracking-[2px]">{props.children}</h2>
  </div>
);

export { LinkGroupHeading };
